export default {
    "welcome": "ໝາຍເລກສອບເສັງ ໝາຍເລກສອບເສັງ",
    "header": {
        "headerMenu": {
            "switchClinics": "Switch Clinics",
            "changePwd": "Change Password",
            "frequentlyUsed": "常用功能",
            "multiLang": "多语言",
            "logout": "Log Out",
            "switchLang": "Switch Language"
        },
        "changePwdModal": {
            "title": "Change Password",
            "tabs": [
                "SMS Verification Code Change",
                "Password Change"
            ],
            "formPhr": {
                "mobile": "Telephone",
                "code": "SMS Verification Code",
                "sendBtn": "Get SMS",
                "sendBtnWait": "Retrieve again in {sec} seconds",
                "password": "Password",
                "confirmPwd": "Re-enter New Password",
                "oldPassword": "Current Password",
                "newPassword": "New Password",
                "confirmBtn": "Save Changes"
            }
        },
        "changeTenantModal": {
            "title": "Switch Clinics",
            "okBtn": "Close",
            "lastLogin": "Last Login Time: ",
            "msgLoading": "Switching in progress, please wait.",
            "msgSuccess": "Switching successful!"
        },
        "logoutModal": {
            "title": "Confirm Log Out",
            "content": "Confirm the exit from the current account?"
        },
        "msgCode": {
            "registerFail": "The phone number is not registered",
            "success": "Verification code sent successfully."
        },
        "msgUpdatePwd": {
            "success": "Password changed successfully",
            "mobileFail": "Please enter the correct phone number",
            "codeFail": "The SMS verification code is incorrect",
            "pwdFail": "The password format is incorrect",
            "pwdSameFail": "The two password inputs are inconsistent"
        },
        "switchLang": {
            "title": "Switch Language",
            "warning": "Do not modify the contents of the symbol {}to avoid abnormal operation of the program"
        }
    },
    "exception": {
        "desc": "Sorry, the page you are looking for does not exist or is still under development",
        "back": "Return to home page"
    },
    "loginPage": {
        "loginForm": {
            "tabs": [
                "Log In With Your Password",
                "Verification Code Login"
            ],
            "account": "Telephone",
            "password": "Password",
            "forgetPwd": "Forgot Password",
            "code": "SMS Verification Code",
            "sendBtn": "Get SMS",
            "sendBtnWait": "Retrieve again in {sec} seconds",
            "autoLogin": "Keep Me Logged In",
            "login": "Log in",
            "loginLoading": "Logging in, please wait",
            "forgetTitle": "Forgot Password",
            "setPassword": "Password",
            "confirmPwd": "Re-enter Password",
            "confirmChange": "Save Changes",
            "hasAccount": "Existing Account?",
            "highLight": "Log In"
        },
        "selectTent": {
            "logout": "Chang Account",
            "search": "Clinic name search",
            "lastLogin": "Last Login Time: ",
            "lastLoginNone": "-",
            "listNone": "No clinics available for login"
        },
        "leftTopLOGO": {
            "tententName": "WANG ZHEN YUN CLINIC MANAGEMENT PLATFORM",
            "tententNameSmall": "WANG ZHEN YUN CLINIC MANAGEMENT PLATFORM"
        },
        "rightTopBtns": {
            "vedio": "演示视频",
            "freeUse": "免费试用"
        }
    },
    "account": {
        "roleSearchPlaceHolder": "Role Name Search",
        "roleTitle": "Role",
        "roleInfo": "Role Information",
        "addRole": "Add Role",
        "rolePermission": "Role Authority",
        "name": "Role Name",
        "isStop": "Enable/Disable",
        "menuName": "Module Name",
        "userSearchPlaceHolder": "Telephone / User Name Search",
        "addUser": "Add User",
        "authority": "Authority",
        "userInfo": "User Information",
        "doctorProfile": "Doctor Profile",
        "visiblePatient": "It can be seen that all patients visited：",
        "roleList": "Role List",
        "setPermission": "Permissions Setting",
        "permissionSet": "Permissions Setting",
        "mobile": "Telephone",
        "job": "Duties",
        "positionalTitles": "Job Title",
        "ybgjCode": "National Medical Insurance Code"
    },
    "doctorWorking": {
        "filter": {
            "patiname": "Patient Name Search",
            "fastRegis": "Quick Consultation",
            "tab_1": "Wait",
            "tab_2": "Diagnosed"
        },
        "viewWork": "My Workload",
        "telPrefix": "",
        "memo": "Remark:",
        "reportBtn": "View Report",
        "historyBtn": "Historical Records",
        "tabExtra": {
            "setDrop_1": "Module Setting",
            "setDrop_2": "Medical Record Setting",
            "menuBtn": "Package",
            "menuDrop_1": "Drug Package",
            "menuDrop_2": "Treatment Package",
            "saveTemBtn": "Save As Template",
            "saveForm": {
                "packageName": "Template Name",
                "memo": "Notes"
            },
            "templateBtn": "Prescription Template",
            "submitBtn": "Completed"
        },
        "negotiateAmt": "Price to Be Collected:",
        "bargain": "Bargain",
        "bargainTip": "Click Completed, Bargain can be effective",
        "recoverBtn": "Recover",
        "bargainMemo": "Notes",
        "recoverDefault": "Restore Default",
        "setTitle_1": "Choose needs to display module",
        "setTitle_2": "Choose the required medical field",
        "statisticAll": "In Total",
        "submitSuccess": "Completed!",
        "chargedTip": "The toll collector has charged for the prescription. If necessary, a new prescription can be issued after a refund.",
        "checkLength": "Select at least one piece of data!",
        "judge": "Insufficient inventory",
        "tipName": "【{name}】",
        "modal": {
            "report": "View Report",
            "history": "Historical Medical Records",
            "stack": "Prescription Template",
            "print": ""
        },
        "verifyLimit": {
            "noneName": "Ordinary",
            "nameJoin": "，",
            "joinName": "[{names}] is a {typeName} class drug; ",
            "unTypeSame": "Different categories of medications cannot be prescribed on the same prescription!",
            "unLimitSame": "Cannot be prescribed on the same prescription as {name} medications!"
        }
    },
    "examine": {
        "executionReport": {
            "queryText": "Patient Name / Examination Number / Examination Item Search",
            "inspectionType": "Search Type",
            "saveReport": "Save Report",
            "cancelAudit": "Cancel Review",
            "auditReport": "Review Report",
            "printReport": "Print Report",
            "risReport": "Examination Information:",
            "lisRegisterTitle": "ໝາຍເລກສອບເສັງ Examination Number:",
            "uploadImg": "Upload Image",
            "pleaseUplad": "Please upload {name}",
            "noData": "no data",
            "formLabelSetting": "{name} Setting",
            "configDefault": "Set as Default",
            "default": "Default",
            "addFormLabel": "Add {name}",
            "lisName": "Lab.",
            "risName": "Exam."
        }
    },
    "execution": {
        "filter": {
            "patiName": "Name",
            "date_1": "Consultation Date",
            "date_2": "End Date"
        },
        "tab_1": "Pending Execution",
        "tab_2": "Executed",
        "tag": "Diagnosis",
        "history": "Historical Medical Records",
        "historyPrint": "Prescription Reprint",
        "record": "Execution Record",
        "recordMemo": "Executive Notes",
        "cancelUser": "Cancelled by",
        "registerUser": "Registrar",
        "deleted": "Cancelled",
        "cancelBtn": "Cancel",
        "execModal": {
            "title": "Execute",
            "execTime": "Execution Time",
            "checkAll": "Select All",
            "execCount": "Executed",
            "execTimes": "This execution",
            "timesUnit": "time",
            "execLabel": "Executive Information",
            "execUser": "Executor",
            "execMemo": "Executive Notes",
            "execChoose": "Please select the execution project!",
            "execUserChoose": "Please select operator!"
        },
        "setModal": {
            "title": "Notes Setting",
            "name": "Notes"
        },
        "loading": "Loading, please try again later!",
        "mustChoose": "Please select a medical record first!",
        "cancelModal": {
            "title": "Confirm cancel execution",
            "content": "Confirm cancel execution?"
        },
        "disposal": {
            "title": "Execution Information",
            "execCount": "Execute ({count}/{amount})"
        },
        "injection": {
            "print_1": "Print Injection Sheet",
            "print_2": "Print Bottle Sticker",
            "title": "Execution Information",
            "groupTitle": "Injection Group {no}",
            "execCount": "Execute ({count}/{allCount})",
            "skinTitle": "Skin Test Information",
            "skinText": "Skin Test",
            "skinResult": "Result",
            "skinEdit": "Edit",
            "skin_1": "Negative(-)",
            "skin_2": "Positive(+)",
            "execName": "Executor",
            "execTime": "Execution time",
            "execMemo": "Notes",
            "column": {
                "chargeUnitnum": "Single Quantity",
                "skin": "Skin Test"
            }
        },
        "execSuccess": "Successfully!"
    },
    "inspect": {
        "machineList": {
            "addBtnTxt": "Add Equipment",
            "warning": "Manually added instruments do not support automatic connection.",
            "machineForm": "Equipment Information",
            "machineName": "Equipment Name"
        },
        "components": {
            "simplingInfo": "Sample Group Information",
            "gender": "Gender",
            "age": "Age",
            "minValue": "Minimum Value",
            "maxValue": "Maximum Value",
            "addItem": "Add",
            "patientName": "Patient Name",
            "unKnowSex": "unknown",
            "machineConfirm": "Equipment Examination Confirm",
            "machine": "Equipment",
            "codeOrNameSearch": "Patient Name / Sample Barcode Search",
            "confirmSaveForm": "Confirm Match Test Results?",
            "observationLabel": "Sample Barcode:",
            "patientNameLabel": "Patient:",
            "lisNameLabel": "Detial Items:",
            "machineCode": "Exam Equip. ",
            "reportPrint": "Reprint Report",
            "projectNameLabel": "{name} Information:",
            "condition": "Condition"
        },
        "checkDetails": {
            "searchPlaceholder": "Items Code/Item Names Search",
            "addBtnTxt": "Add Detial Item",
            "editBtnTxt": "Edit Detial Item",
            "integer": "integer",
            "float": "{name} decimal place",
            "resultType1": "Numeric",
            "resultType2": "Character",
            "resultType3": "Negative/Positive",
            "resultType4": "Computational",
            "moreGroup": "Multiple Units",
            "oneFroup": "Single Unit",
            "Uncomputation": "Uncomputation"
        },
        "detailsRelevance": {
            "lisWorkgroupPlaceholder": "Sample Group",
            "queryTextPlaceholder": "Name / Pinyin Code Search",
            "addLisTitle": "Add Detial Item",
            "editLisTitle": "Edit Detial Item",
            "rightTab": "Detial Items Relevance",
            "rightAddBtnTxt": "Add Detial Item",
            "projectName": "Item Name:",
            "addChildrenPlaceholder": "Please input Itemized code or name",
            "childrenIsExist": "Detial Item already exists!",
            "pleaseChooseItem": "Please select an Detial item!",
            "delTip": "[{name}] cannot be recovered after deletion (deletion range includes associated files, form details, prescription template details), are you sure to delete? ",
            "isSaveFormTip": "Confirm save {name} Detial Items？"
        },
        "sampling": {
            "addBtnTxt": "Add Sample Group",
            "warning": "All Detial items are grouped according to the sampling group. Only one sample is collected and one sample bar code is generated for each item in the same sampling group.Test results are combined in a single report"
        },
        "inspectReport": {
            "queryText": "Patient Name / Sample Barcode / Detial Item Search",
            "printCode": "Print Barcode",
            "saveReport": "Save Report",
            "cancelAudit": "Cancel Review",
            "auditReport": "Review Report",
            "printReport": "Print Report",
            "lisReport": "Test Information:",
            "fastCopy": "Simple Copy"
        },
        "signIn": {
            "startTime": "Start Date",
            "endTime": "End Date",
            "queryText": "Patient Name / File No. Search",
            "recordCode": "File No.:",
            "signAndPrint": "Acknowledge and Print the Barcode",
            "unSign": "Cancel Acknowledgement",
            "printCode": "Print Barcode",
            "receive": "ACK",
            "unReceive": "NACK",
            "unSignTip": "Please check the unacknowledged detial items!",
            "signTip": "Please check the acknowledged detial items!",
            "signSuccess": "Acknowledge Successfully!",
            "returedSuccess": "Cancel Acknowledgement Successfully!"
        },
        "common": {
            "samplingName": "Sampling Group Name",
            "workgroupColorId": "Sampling Tube",
            "machineName": "Machine Name",
            "channelNumber": "Channel No.",
            "subLisCode": "Item Code",
            "subLisName": "Item Name",
            "orderMemoForCustomer": "Significance",
            "options": "Options",
            "computationalFormula": "Computational Formula",
            "resultTypeName": "Result Type",
            "decimalPlace": "Decimal Places",
            "unitName": "Unit",
            "fanWei": "Reference Range",
            "referenceValue": "Reference Value",
            "projectName": "Item Name",
            "hospitalName": "Detial Item Name",
            "specimenTypeName": "Specimens",
            "lisWorkgroupName": "Sample Group",
            "subLisCodeSimple": "Code",
            "isStop": "Enable/Disable",
            "edit": "Edit",
            "observationId": "Sample Barcode",
            "orderName": "Detial Items",
            "chargeStatus": "Charging Status",
            "creationTime": "Billing Time",
            "chargeTime": "Charging Time",
            "checkInTime": "Acknowledgement Time",
            "analysisTime": "Test Time",
            "patientName": "Patient",
            "openContentService": "{name} Confirm enable?",
            "openContent": "[{name}] Confirm disable?",
            "stopContentService": "{name} Confirm disable?",
            "stopContent": "[{name}] Confirm disable?？",
            "delContentService": "{name}, are you sure to delete it",
            "delContent": "[{name}] are you sure to delete it？",
            "openTip": "Confirm Enable [{name}]？",
            "stopTip": "Confirm disable [{name}]？",
            "diseaseName": "Diagnosis:",
            "beCharge": "Charged",
            "unBeCharge": "Not charged",
            "machine": "Equipment",
            "status": "Status",
            "auditStatus_1": "Pending Test",
            "auditStatus_2": "Pending Review",
            "auditStatus_3": "Reviewed",
            "visitTypeTitle": "ຊັບພະຍາກອນ Resource:",
            "observationTitle": "ບາໂຄດຕົວຢ່າງ Sample Barcode:",
            "specimenNameTitle": "ຕົວຢ່າງ Speciman:",
            "applyTimeTitle": "ເວລາຄໍາຮ້ອງສະຫມັກ Application Time:",
            "reportPeopleNameTitle": "ນັກຂ່າວ Reporter:",
            "reportTimeTitle": "ເວລາລາຍງານ Report Time:",
            "auditReeopleNameTitle": "ຜູ້ທົບທວນ Reviewer:",
            "auditTimeTitle": "ເວລາທົບທວນ Review Time:",
            "projectCode": "Item Code",
            "resultValue": "Reminder",
            "result": "Result",
            "remarkTitle": "Notes:",
            "auditReportSuccessTip": "Review Report Successfully!",
            "saveReportSuccessTip": "Save Report Successfully!",
            "confirmCancelAudit": "Confirm Cancel Review？",
            "cancelAuditSuccessTip": "Cancel Review Successfully!",
            "compareSuccessed": "Match Successfully!"
        }
    },
    "maintenance": {
        "tabsList": {
            "deptInfo": "Department",
            "collectFee": "Charge Item",
            "formMaintain": "Form",
            "storeroom": "Storage",
            "kzLevel": "Consultation Level",
            "diagnosis": "Diagnosis",
            "setting": "System Setting"
        },
        "outpatient": "Outpatient",
        "inpatient": "Inpatient",
        "deptPlaceHolder": "Department / Room Name Search",
        "addDept": "Add Department",
        "deptInfo": "Department Information",
        "deptName": "Department Name",
        "ybDeptOne": "医保科室",
        "ybDeptTwo": "子科室",
        "stopReason": "Discontinuation Reason",
        "room": "Room",
        "roomInfo": "Room Information",
        "addRoom": "Add Room",
        "roomName": "Room Name",
        "roomLocation": "Room Location",
        "stopTips": "Please Enter【{name}】Reason For Deactivation",
        "stopTips3": "Deactivation This department will deactivate corresponding schedules at the same time, please confirm whether to operate?",
        "startTips1": "Confirm Enable",
        "startTips2": "Confirm Enable【{name}】?",
        "delTips1": "Confirm Deletion",
        "delTips2": "Confirm Deletion【{name}】?",
        "tipsReason": "Please enter the reason for deactivation!",
        "deptFrom": "Belonging Department",
        "deptFromName": "Department name",
        "openLis": "Enable lab.  management",
        "runLis": "Perform lab.",
        "creatCanLis": "Lab.  shall be performed after prescription",
        "payCanLis": "Lab.  shall be performed after charging",
        "lisSign": "Lab.  acknowledgement",
        "signCanReport": "Report shall be filled in with Lab.  acknowledgement",
        "unSignCanReport": "Report shall be printed without reviewed",
        "openRis": "Enable examination management",
        "runRis": "Perform examination",
        "creatCanRis": "Examination shall be performed after prescription",
        "payCanRis": "Examination shall be performed after charging",
        "risAudit": "Examination report review",
        "auditCanPrint": "Report shall be printed after reviewed",
        "unAuditCanPrint": "Report shall be printed without reviewed",
        "lisConfig": "Lab. setting",
        "risConfig": "Examination setting",
        "InstitutionConfig": "InstitutionInfor",
        "institution": {
            "institutionName": "InstitutionName",
            "contactNumber": "ContactNumber",
            "address": "Address",
            "detailedAddress": "DetailedAddress"
        },
        "collectFee": {
            "tabAll": "All",
            "filter": {
                "drugType": "Drug Classification",
                "drugMainform": "Dosage Forms Classification",
                "queryText": "Name / Shorthand Code / Barcode Search"
            },
            "actBtns": {
                "addProject": "Add Item",
                "addPrefix": "Add "
            },
            "tableTitle": {
                "name": "Query Item",
                "total": "Item Total "
            },
            "tableAct": {
                "edit": "Edit",
                "del": "Delete"
            },
            "tableColumn": {
                "orderCode": "Internal Code",
                "orderTypeName": "Item Type",
                "price": "Sales Unit Price",
                "chargeUnitName": "Sales Unit",
                "medListCodg": "医保编码",
                "creationTime": "Creation Date",
                "status": "Enable/Disable"
            },
            "removeModal": {
                "title": "Confirm Deletion",
                "content": "[{name}] Cannot be recovered after deletion (the deletion range includes associated files, form details, prescription template details), confirm deletion?"
            },
            "statusModal": {
                "status_1": "Disable",
                "status_2": "Enable",
                "title": "Confirm {status}",
                "content_1": "Current inventory {chargeUnitText}{minUnitText}, confirm deactivation?",
                "content_2": "Confirm {title} 【{chScientificName}】?"
            },
            "exportName": "Charge item maintenance-{d}"
        },
        "collectEdit": {
            "breadcrumb": {
                "label_1": "Charge Items",
                "label_edit": "Edit ",
                "label_add": "Add "
            },
            "clearBtn": "Clear",
            "platLabel": "Add From Platform",
            "plat_p1": "Name / Barcode / Chinese Drug Approval Number Search",
            "plat_p2": "Name / Barcode Search",
            "search": "Search",
            "drugType": "Drug Classification",
            "drugMainformType": "Classification Of Dosage Forms",
            "chargeUnit": "Packaging unit",
            "chargeUnit_2": "Sales Unit",
            "unitSplit": "contain",
            "minUnit": "Minimum unit",
            "dosageUnit": "Dose unit",
            "hisPriceBtn": "History",
            "hisTop": "All-Time High",
            "hisEnd": "All-Time Low",
            "pruchasingBtn": "Purchasing Price",
            "sciNamePyCode": "Generic Name Shorthand Code",
            "pyCode": "Trade Name Shorthand Code",
            "unitPlace": "Unit",
            "relatedTitle": "Associated Addition Maintenance",
            "relatedLabel": "Associated Addition",
            "relatedSearch": "Associated Addition Search",
            "tipConversion": {
                "title": "Example Conversion Relation",
                "p_1": "Minimum unit refers to the unit of the smallest specification, such as tablet, pellet, branch, when a single dose is less than the minimum unit, according to the minimum unit to calculate the quantity of medicine.",
                "p_2": "Taking azithromycin tablets as an example, the specification is 0.2g*10 pieces per box, then the conversion relationship is maintained:",
                "p_3": "each packaging unit",
                "p_4": "box",
                "p_5": "pieces",
                "p_6": ", and each"
            },
            "modalMsg": {
                "bigHasKucun": "The charge item has inventory. Please update {text} after it has been removed from stock!",
                "bigStorage": "Due to the storage entry record, the status of the original charge item will need to be disabled when you modify {text}. A new piece of data will be added after modification. Confirm modification?",
                "minHasKucun": "The minimum unit of the current charge item has inventory, please edit the minimum unit after delivery!",
                "minStorage": "Due to existing inventory records, when modifying the smallest unit, the status of the original item needs to be changed to 'Inactive', and a new modified data entry will be added. Confirm the modification?"
            },
            "platColumn": {
                "guoyaozhunzi": "Approval Number",
                "barCode": "Barcode"
            },
            "renderForm": {
                "orderCode": "Internal Code",
                "chScientificName": "Generic Name",
                "chScientificNameSuffix_1": " Name",
                "chScientificNameSuffix_2": " Name",
                "chTradeName": "Trade Name",
                "drugType": "Drug Classification",
                "drugSpec": "Specification",
                "opdTransrate": "Per Packaging Unit",
                "dosageTransrate": "Minimum Saleable Unit",
                "price": "Sales Unit Price",
                "dismantlePrice": "Allow Splitting",
                "substituteOrderCode": "Barcode",
                "permitCode": "Approval Number",
                "manufacture": "Manufacturer",
                "pinyinCode": "Shorthand Code",
                "drugFormType": "Dosage Form Subclassification",
                "drugLimitType": "Restriction Category",
                "pharmacologyType": "Pharmacology Category",
                "antibioticLevelType": "Antibacterial Drug Level",
                "dosage": "Default Dosage",
                "freq": "Default Frequency",
                "usages": "Default Usage",
                "costPrice": "Cost Unit Price",
                "feesProcessed": "Processing Fee",
                "specimenType": "Sample",
                "lisWorkgroup": "Sampling Group",
                "lisWorkgroupTip": "All detial items are grouped according to the sampling group. Only one sample is collected and one sample bar code is generated for each item in the same sampling group.Test results are combined in a single report",
                "instrument": "Equipment",
                "inspectionType": "Type",
                "inventoryUpper": "Maximum Inventory Limit",
                "inventoryFloor": "Minimum Inventory Limit",
                "orderMemo": "Order Entry Information",
                "medicationDetais": "Notes Or Medication Detais",
                "filelist": "Promotional Image",
                "orderMemoForCustomer": "Significance"
            },
            "relatedTableColumn": {
                "chScientificName": "Name",
                "drugSpec": "Specification",
                "tqty": "Total"
            },
            "relatedColumn": {
                "orderTypeName": "Item Type",
                "chScientificName": "Item Name",
                "drugSpec": "Specification",
                "chargeUnitName": "Outpatient Unit"
            }
        },
        "diseaseType": "Diagnoses Classification",
        "diseasePlaceholder": "Diagnoses Name Search",
        "d_addInfo": "Diagnoses Information",
        "diseaseCode": "Diagnoses Code",
        "diseaseName": "Diagnoses Name",
        "sortOrder": "Sort",
        "sheetMainType": "Form Type",
        "addSheet": "Add Form",
        "editSheet": "Form Maintenance",
        "formColumn": {
            "chScientificName": "Item Name",
            "specimen": "Specimen"
        },
        "sheetInfo": "Form Infomation",
        "sheetDrug": "Form Order",
        "isStop": "Enable/Disable",
        "chSheetName": "Form Name",
        "separateSheetName": "Split Order Methed",
        "sheetRemarks": "Notes",
        "chooseSpecimenTips": "Please select a specimen!",
        "kzLevel": "Consultation Level",
        "addKzLevel": "Add Consultation Level",
        "kzLevelInfo": "Consultation Level Information",
        "ghTitle": "Registration Fee",
        "ghTitleInfo": "(Please go to the 'Charge Items' module to edit the registration fee)",
        "chKzLevelName": "Consultation Level Name",
        "pyCode": "Shorthand Code",
        "amount": "Price",
        "name": "Name",
        "expenseCategoryName": "Charge Items",
        "storeroom": "Pharmacy Management",
        "storeroomName": "Pharmacy Name",
        "storeroomInfo": "Pharmacy Information",
        "addStoreroom": "Add Pharmacy",
        "toChoose": "Please Select",
        "westernMedicineDeductSetup": "Western Drug Stock Pharmacy: ",
        "chinesePatentMedicineDeductRoom": "Chinese Patent Drug Stock Pharmacy: ",
        "chineseHerbalMedicineRoom": "Chinese Herbal Drug Stock Pharmacy: ",
        "medicalComponentDeductRoom": "Consumable Stock Pharmacy: ",
        "setting_tab_1": "Charge Setting",
        "setting_tab_2": "Data Permission",
        "setting_tab_3": "Outpatient Setting",
        "setting_tab_4": "Print Setting",
        "setting_tab_5": "Pharmacy Setting",
        "setting_tab_10": "Exchange Rate Setting",
        "designeeAllowToSee": "Designated person can view",
        "designeeAllowToSee_1": "{num} people have been selected. Modify",
        "choose": "Select",
        "tab1_fy": "Simultaneously Administering Medication",
        "tab1_fy_1004": "At the same time of outpatient charges, medicine is dispensed by default",
        "tab1_fy_1005": "Simultaneous delivery is the default for retail billing",
        "tab1_xp": "Print Receipt",
        "tab1_xp_1016": "The member will print a receipt by default when recharging",
        "tab1_yj": "Negotiate Price",
        "tab1_yj_1009": "Whole price bargaining is allowed during outpatient registration",
        "tab1_yj_1010": "Whole order bargaining is allowed for outpatient charges",
        "tab1_yj_1011": "Whole order bargaining is allowed for retail charges",
        "tab2_jj": "【Charge Item Maintenance】Drugs, Consumable Purchase Price",
        "tab2_1012_1013": "Have【charge item maintenance】permission to view",
        "tab2_cbj": "【Charge Item Maintenance】Project cost price except for drugs and Consumable",
        "tab2_ypjg": "【Outpatient】Doctors check drug prices",
        "tab2_ypjg_1014_1": "Allow to see the drug unit price, total price",
        "tab2_ypjg_1014_2": "Only the total price of the drug is allowed to be seen",
        "tab2_ypjg_1014_3": "The unit price and total price of drugs are not allowed to be seen",
        "tab2_mzzy": "【Outpatient】",
        "tab2_mzzy_1001": "Medicine, Consumable stock shortage can be opened",
        "tab2_lssf": "【Retail Charge】",
        "tab2_lssf_1002": "Drugs, Consumable inventory is insufficient can be charged",
        "tab3_kzyl": "【Outpatient】Preview and confirm the complete medical record and prescription after the consultation",
        "tab3_kzyl_1015": "Those with【Outpatient】permissions need to preview and confirm",
        "tab3_designeeAllowToSee": "Designated person preview confirmation",
        "tab3_kzyj": "【Outpatient】Doctors are allowed to negotiate the price during the Consultation",
        "tab3_kzyj_1017_1": "Those with the authority of 【Outpatient】 are allowed to negotiate",
        "tab3_kzyj_1017_2": "Doctors are not allowed to bargain",
        "tab3_kzyj_1017_3": "Designated personnel allow bargaining",
        "tab3_kzsf": "【Outpatient】Doctors can be charged directly after the completion of the Consultation",
        "tab3_kzsf_1037_1": "Direct charges are not allowed",
        "tab3_kzsf_1037_2": "Any Consultation with the authority of \"outpatient Surgery\" can be charged directly",
        "tab3_kzsf_1037_3": "Designated personnel can be charged upon completion of the Consultation",
        "tab3_szyl": "【Outpatient】【Prescription Template】Calculation rules for infusion drug dosage",
        "tab3_szyl_1026_1": "Discard drugs that are not used up in a single dose",
        "tab3_szyl_1026_2": "Retain unused single dose of medication",
        "tab3_szyl_1026_1_expend": "For example: the specification is 250ml/ bottle, the single dose is 150ml, 3 times a day, and the automatic total amount of the system is ",
        "tab3_szyl_1026_1_expend_unit": " bottles",
        "tab3_rkxgdj": "【Stock-in Management】Modify the unit price when filling in the storage form",
        "tab3_rkxgdj_1027": "Have 【Stock-in Management】 permission can be modified",
        "tab3_rkxgdj_1027_1": "Unmodifiable",
        "tab3_rkxgdj_1027_2": "Designated personnel can be modified",
        "tab3_rkhxg": "【Storage management】 After the storage is confirmed, the storage record can be modified",
        "choosePerson": "Select Personnel",
        "choosedPerson": "Selected Personnel",
        "choosingPerson": "Optional Personnel",
        "settingDataErrorTips": "Failed to get Settings data",
        "tab3_zybz": "【Outpatient】【Prescription Template】 Chinese medicine prescription Remarks Default content",
        "invoiceConfig": {
            "showType_1": "Displays the item name, quantity, and price",
            "showType_2": "Show the item name and quantity, not the price",
            "showType_3": "Display \"{name} fee\" and total price",
            "freeType1018": "Drug",
            "freeType1019": "Chinese Herbal Drug",
            "freeType1020": "Consumable",
            "freeType1021": "Laboratory",
            "freeType1022": "Examination",
            "freeType1023": "Treatment",
            "freeType1024": "Surgery",
            "freeType1025": "Infusion Additional Items",
            "freeType1038": "收费员",
            "freeType1039": "收费时间",
            "freeType1040": "Telephone",
            "freeType1041": "Address",
            "feeReceipt": "Charge Receipt",
            "invoice": "Receipt",
            "ticket": "Receipt",
            "clinicName": "WANG ZHEN CLOUD",
            "payNote": "Pay Demand Note",
            "actionType": "{name} Fee",
            "invoiceItem_1": "Name： Mr Wang",
            "invoiceItem_2": "Sex： male",
            "invoiceItem_3": "Age： 66Y",
            "invoiceItem_4": "Cost Category： Self-pay",
            "invoiceItem_5": "Doctor：Doctor Wang",
            "invoiceItem_6": "Department： Otology",
            "invoiceItem_7": "Toll Collector：Doctor Wang",
            "receivable": "Amount Receivable",
            "receiptAmt": "Actual Received",
            "cash": "Cash",
            "weChat": "Wechat",
            "payTime": "Charge Time",
            "moneyUnit": "₭",
            "freeTypeName1018": "Drug Name",
            "freeTypeName1019": "Chinese Herbal Drug Name",
            "freeTypeName1020": "Consumable Name",
            "freeTypeName1021": "Laboratory Name",
            "freeTypeName1022": "Examination Name",
            "freeTypeName1023": "Treatment Name",
            "freeTypeName1024": "Surgery Name",
            "freeTypeName1025": "Infusion Additional Items Name",
            "unit_dai": "box",
            "unit_pian": "box",
            "unit_ci": "once",
            "unit_dance": "once",
            "unit_tie": "stick"
        },
        "saveInspectModal": {
            "modalTitle": "启用检查管理",
            "alertTip": "启用检查管理，需补全以下检查项目的检查类型",
            "inspectionTypeId": "检查类型",
            "hospitalName": "检查项目名称",
            "formConfirmTips": "{name}请选择检查类型！"
        },
        "saveMaterialModal": {
            "modalTitle": "启用检验管理",
            "alertTip": "启用检验管理，需补全以下检验项目的检体，采样组信息",
            "formConfirmTips": "{name}请选择检体或采样组！"
        },
        "exchangeRate": {
            "title": "Exchange Rate",
            "historyBtn": "Historical Exchange Rate",
            "delMsg": "删除该汇率换算公式后，收费时不支持使用{type}支付？"
        }
    },
    "outpatientCollectfee": {
        "collectfee": {
            "filter": {
                "patiName": "Name Search",
                "dateBtn_d1": "Today",
                "dateBtn_d3": "Last 3 D.",
                "dateBtn_d5": "Last 5 D.",
                "dateBtn_d": "Defined"
            },
            "tab_1": "Uncharged",
            "tab_2": "Charged",
            "isNoCharge": "No Charge",
            "showNoCharge": "Display No Charge",
            "mainIdentity": "Settlement Category",
            "medType": "Medical Category",
            "confirmBtn": "Confirm Charge",
            "negotiatePriceAmt": "Doctor Bargaining",
            "totalAmount": "Total Cost",
            "diagnosis": "Diagnosis",
            "payModalTitle": "Determine Fees",
            "columnPrice": "Unit-price",
            "columnTqty": "Number",
            "columnAmount": "Expense",
            "tip_1": "The patient has been charged!",
            "tip_2": "The original bill has changed!",
            "tip_3": "The patient has been charged, please do not charge again!",
            "tip_4": "The original bill has changed, please confirm the payment again!",
            "mustChoose": "Please select a medical category!",
            "paySuccess": "Charge Successfully!",
            "noChargeContent": "Confirm that the current bill is temporarily not charged?"
        },
        "dividePrice": {
            "pageName": "Charge",
            "form": {
                "patiname": "Patient Name",
                "birthdatetime": "Date Of Birth",
                "sex": "Gender",
                "mainIdentity": "Consultation Identity",
                "section": "Department",
                "employee": "Doctor",
                "diagnoses": "Diagnosis"
            },
            "btnSuffix": "Prescription",
            "confirmBtn": "Determine Fees",
            "payModalTitle": "Determine Fees",
            "mustOne": "Keep at least one prescription",
            "minOne": "Please add the prescription drug first",
            "tqtyUnZero": "{name} The total cannot be empty"
        },
        "search": {
            "employeePlaceholder": "Doctor",
            "creatorUserPlaceholder": "Toll Collector",
            "patiNamePlaceholder": "Patient Name Search",
            "tollCollector": "Toll Collector: ",
            "chargebackClerk": "Refund Clerk: ",
            "returnPremium": "Refund",
            "returnPremiumSuccess": "Refund Successfully!",
            "xp": "Receipt",
            "invoice": {
                "invoiceType_1": "Medical Invoice",
                "invoiceType_2": "Charge Receipt",
                "invoiceNumber": "Invoice No.: ",
                "invoiceSetting": "Print Setting"
            },
            "unitPrice": "Unit-price",
            "totalAmount": "Price",
            "zcyTqty": "*{num} Doses",
            "cancelReasonName": "Refund Reason: ",
            "charged": "Charged",
            "refund": "Refunded",
            "refundTips": "No refund for medicine already dispensed!",
            "refundInvoice": "If the refund is successful, the corresponding invoice number {num} is directly invalid!",
            "refundInvoice_1": "Refund successful, corresponding invoice number ",
            "refundConfirm": "Confirm Refund",
            "refundConfirm_1": "Are you sure to refund the fee?"
        },
        "report": {
            "startDate": "Checkout Date",
            "detailModalTitle": "Details Of Outpatient Collection Date",
            "yjMemo": "Bargain Note: ",
            "exportName": "Daily fee settlement report",
            "tableSet": {
                "chargeUserName": "Toll Collector",
                "totalMedicalAmt": "Total Receivables",
                "totalDiscountAmt": "Discount",
                "totalBargainAmt": "Bargain",
                "totalShortAmt": "Deficit",
                "totalRefundAmt": "Refund",
                "totalRealAmt": "Actual Received",
                "payType": "Payment Method",
                "weChat": "Wechat",
                "alipay": "Alipay",
                "merge": "Aggregate Payment",
                "cash": "Cash",
                "member": "Member",
                "ybCard": "Medicare Card",
                "numerRMB": "Digital yuan",
                "total": "Subtotal",
                "yb": "医保",
                "ybMedicarePay": "统筹基金(元)",
                "ybPersonalPay": "个人账户(元)",
                "projectType": "Item Type",
                "western": "Drug",
                "tranditionalMedicine": "Proprietary Chinese Drug",
                "chinese": "Chinese Herbal Drug",
                "medical": "Consumable",
                "inspectFee": "Laboratory",
                "check": "Examination",
                "treat": "Treatment",
                "operation": "Surgery",
                "register": "Consultation Fee",
                "infusionFee": "Infusion Addition"
            }
        },
        "amtInfo": {
            "all": "Total Cost: ",
            "fmoney": "₭ {money}",
            "tcjj": "统筹基金",
            "grzh": "个人账户",
            "yhje": "Discount Price",
            "yj": "Bargain",
            "dyk": "Deficit",
            "ssjj": "Actual Received"
        }
    },
    "outpatientRegistration": {
        "patientStatusList": {
            "placeHolder": "Patient Name / Telephone Search",
            "signIn": "Sign In",
            "registration": "Registration",
            "prediagnosis": "Pre-Diagnosis",
            "paddingDiagnosis": "Wait",
            "finishDiagnosis": "Diagnosed",
            "all": "All",
            "makeAnAppointment": "Appointment",
            "yzTitName": "【{name}】Prediagnosis"
        },
        "booking": {
            "placeHolder": "Doctor Name Search",
            "today": "Today",
            "tomorrow": "Tomorrow",
            "dayAfterTomorrow": "Day After Tomorrow",
            "appointmentRegister": "Registration",
            "appointmentRegisterTitle": "Appointment Registration",
            "appointmentSignIn": "Sign In",
            "cancelAnAppointment": "Cancel",
            "returnTheNumber": "Cancel Registration",
            "caseHistory": "Medical Record",
            "suspendMedicalService": "Stop Diagnosis",
            "beginToTreatPatients": "Start Diagnosis",
            "wayOfRegistration": "Registered Method",
            "notTelTips": "No cellphone number provided",
            "isCancelAnAppointment": "Cancel the appointment?",
            "historicalMedicalRecord": "Historical Medical Records",
            "prescriptionReprinting": "Prescription Reprint",
            "pleaseSelectData": "Please select a medical record first!",
            "doctorName": "Doctor",
            "patientSearch": "Patient’s Name Search",
            "registerList": {
                "doctorUserName": "Doctor’s Name",
                "timeInterval": "Time Slot",
                "roomName": "Clinic Room",
                "patiName": "Patient’s Name",
                "age": "Age",
                "mainIdentityName": "Medical Identity",
                "registerChannelName": "Appointment Pathway",
                "visitStatusName": "Status"
            },
            "remainNumber": "Remaining Number({num})",
            "ghScheduleTips": "Please select an appointment time!",
            "stopScheduleInfo": "Clinic Closure"
        },
        "scene": {
            "card_title": "All Doctors",
            "filter": {
                "section": "Department",
                "doctorName": "Doctor Name Search"
            },
            "actBtn": "Registration",
            "btmLine": "Registered",
            "person": ""
        },
        "inquire": {
            "filter": {
                "date": [
                    "Consultation Date",
                    "End Date"
                ],
                "mainIdentity": "Consultation Identity",
                "employee": "Consultation Doctor",
                "section": "Department",
                "patientName": "Patient Name Search"
            },
            "actBtn_2": "医疗收费发票",
            "actBtn_3": "Registration Receipt",
            "actBtn_4": "Print Setting",
            "actBtn_5": "Cancel Registration",
            "tableAct": "Pre-diagnosis",
            "tableColumn": {
                "processTime": "Consultation Date",
                "patiName": "Name",
                "sex": "Gender",
                "birthdatetime": "Date Of Birth",
                "mainIdentityName": "Consultation Identity",
                "worktimeName": "Time Period",
                "sectionName": "Department",
                "doctorUserName": "Doctor",
                "doctorLevelName": "Consultation Level",
                "receiptsAmt": "Registered Price",
                "invoiceNumber": "发票号码",
                "registerChannelName": "Registered Method",
                "visitStatusName": "Status",
                "cancelReasonName": "Reason"
            },
            "success": "{t}成功，对应的发票号码{n}直接作废！",
            "exportName": "Registered enquiry (Cancel Registration)-{d}"
        }
    },
    "patient": {
        "recordFile": {
            "filter": {
                "birthday": [
                    "Birth Date",
                    "End Date"
                ],
                "creationTime": [
                    "Filing Date",
                    "End Date"
                ],
                "patiType": "Patients Type",
                "memberId": "Membership Level",
                "queryText": "Patient Name / Telephone / ID Number Search"
            },
            "patiType_1": "All Patients",
            "patiType_2": "Ordinary Patient",
            "patiType_3": "Member Patient",
            "addBtn": "Add",
            "count": "Patients Total",
            "switch_1": "List",
            "switch_2": "Board",
            "rowEdit": "Edit",
            "rowMember": "Membership/Card",
            "rowHistory": "History",
            "rowHistoryCard": "Historical Medical Records",
            "createTime": "Filing Date",
            "rePrint": "Prescription Reprint",
            "rePrintMustChoose": "Please select a medical record first!",
            "column_1": "Name",
            "column_2": "Gender",
            "column_3": "Birth Date",
            "column_4": "Age",
            "column_5": "Telephone",
            "column_6": "Document Type",
            "column_7": "Document Number",
            "column_8": "Filing Date",
            "column_9": "Recent Consultation Date",
            "column_10": "Membership Level",
            "exportName": "Patient records - {date}"
        },
        "member": {
            "openTitle": "Activate membership",
            "openVerifyTel": "The patient's mobile number is not filled in. Unable to activate card!",
            "level": "Membership Level",
            "function": "Member Benefits",
            "edit": "Edit",
            "integralGrant": "Points Issue",
            "integralGrantBtn": "Issue",
            "integralGrantNum": "Issue points",
            "integralGrantMemo": "Notes",
            "intefralExchangeTitle": "Points Exchange",
            "intefralExchangeBtn": "Exchange",
            "intefralExchangeNumber": "Redeem points",
            "intefralExchangeItem": "Exchange items",
            "intefralExchangeMemo": "Notes",
            "writeOff": "Log Off",
            "charge": "Recharge",
            "unpay": "Refund",
            "defaultLevel": "Ordinary patient",
            "chargeModal": {
                "title": "Member Recharge",
                "principalAmt": "Recharge Price",
                "sendAmt": "Gift Price",
                "moneyUnit": "",
                "presend": "Free {n}",
                "seller": "Toll Collector",
                "mark": "Notes"
            },
            "sellerModal": {
                "title": "Salesperson settings",
                "name": ""
            },
            "bread_1": "Patient Information",
            "bread_2": "Membership/Card",
            "renderTitle": {
                "integral": "Points",
                "member": "Membership"
            },
            "listLabel": {
                "availableIntegral": "Points",
                "memberName": "Level",
                "memberMoney": "Balance",
                "memberRight": "Benefits"
            },
            "writeOffModal": {
                "title": "Confirm Logout",
                "content": "Confirm Logout {name}?",
                "tip_1_title": "Balance in the membership cannot be cancelled",
                "tip_1_content": "There is still a balance in the membership, please refund before cancellation",
                "tip_2_title": "Current member has been cancelled",
                "tip_2_content": "The current member has been cancelled. Click OK to refresh."
            },
            "payVerify": "The recharge amount cannot be less than or equal to 0!",
            "payTitle": "Determine Fees",
            "payTip_1": "Refund {type}",
            "payTip_2": "Recharge {type}",
            "balanceColumn": {
                "title": "Balance Statement",
                "creationTime": "Trading Date",
                "tradeTypeName": "Trading Type",
                "payTypeName": "Payment Method",
                "payTotalAmt": "Trading Price",
                "principalAmt": "Trading Principal",
                "sendAmt": "Trading Bonus",
                "principalbalance": "Principal Balance",
                "sendbalance": "Bonus Balance",
                "patiName": "Patient Name",
                "doctorName": "Doctor",
                "sellerName": "Salesman",
                "chargeUserName": "Toll Collector"
            },
            "deductionColumn": {
                "title": "Deduction Benefits Statement",
                "memberItemName": "Deduction Items",
                "creationTime": "Deduction Date",
                "patiName": "Trading Customer",
                "deductionTimes": "Deduction Times",
                "remainTimes": "Remaining Times",
                "doctorName": "Doctor",
                "chargeUserName": "Toll Collector"
            },
            "integralColumn": {
                "title": "Points Statement",
                "creationTime": "Change Time",
                "changeTypeName": "Change Type",
                "exchangeName": "Exchange Ttem",
                "changeIntegral": "Change Points",
                "remainIntegral": "Remaining Points",
                "mark": "Notes",
                "creatorUserName": "Operator"
            }
        }
    },
    "dispense": {
        "startDate": "Charge Date",
        "placeholder": "Patient Name Search",
        "chargeDate": "Charge Time: ",
        "sendMedicineDate": "Dispense Time: ",
        "sendMedicine": "Dispensing",
        "returnMedicine": "Drug Repercussion",
        "toPrint": "Prescription Printing",
        "diagnosisNameJoin": "Diagnosis: ",
        "nameAnd": "{name}, ",
        "herbalMedicineTcmQuantity": "{num} Doses",
        "prescriptionOrderDrug": "{num} pills, ",
        "feesProcessedName": "Contract Processing: ",
        "feesProcessedMomo": ", {memo}",
        "waitSendMedicine": "Awaiting Dispensing",
        "alreadySendMedicine": "Dispensed",
        "days": "{days} Days",
        "daysNum": "Number of Days",
        "returnedMedicine": "Refunded",
        "sendMedicineTips": "This patient has already been prescribed medication, do not repeat prescribing medication!",
        "returnNum": "Returnable quantity",
        "returnMedicineNull": "There is no returnable medicine!",
        "outpatient": "Outpatient",
        "dischargedWithDrugs": "Discharged with Drugs"
    },
    "membership": {
        "member": {
            "memberType": "Membership Type",
            "memberPoints": "Points",
            "createdStartDate": "Creation Date",
            "placeholder": "Member Benefits Search",
            "addMember": "Add Member",
            "memberLevelInfo": "Membership Information",
            "memberLevelName": "Membership Level Name: ",
            "memberLevelNameNot": "Membership Level Name",
            "memberName": "Membership Level",
            "memberRights": "Member Benefits",
            "memberNumber": "Membership",
            "delTips": "Patients have opened the membership, can not be deleted!",
            "price": "Selling Price",
            "hdlx": "Activity type",
            "orderTypeName": "Item Type",
            "memo": "Notes: ",
            "lwChoose": "Exception: {num} selected",
            "zhe": "Discount",
            "discount": "Discounts",
            "bargainPrice": "Special Price",
            "choose": "Select",
            "hdfw": "Activities Scope: ",
            "chooseHdfwProject": "Items participating in the activity",
            "membershipMarketing": "Member Maintenance",
            "czmj": "Full Recharge Is Reduced: ",
            "czmj_1": "Recharge Full",
            "czmj_2": "Kip, Send",
            "czmj_3": "Kip;"
        },
        "chooseModel": {
            "unitCot": "Quantity",
            "choosed": "Selected",
            "placeHolder": "Name Search",
            "example": "Select Exception",
            "project": "Item",
            "projectChoose": "Selected Items",
            "type": "Type"
        },
        "jfForm": {
            "title": "Points Activities: ",
            "syfw": "Range Of Activity: ",
            "allPatient": "All patients",
            "ordinaryPatient": "Ordinary patient",
            "memberPatient": "Designated member",
            "getRule": "Obtain Rules: ",
            "getRuleSuccess": "Points for successful spending",
            "consume": "For every",
            "givePoints": "spent, you get 1 point",
            "chooseMember": "Select Applicable Members",
            "chooseAll": "Select All",
            "suitableRangeTips": "Please select application scope!",
            "getMemberTips": "Please select a specific member!"
        },
        "marketing": {
            "balance": "Membership Statistics",
            "integral": "Point Statistics"
        },
        "balance": {
            "statistics": "Balance Statistics",
            "membershipLevel": "Balance Statistics",
            "beginDate": "Beginning Date",
            "endDate": "Ending Date",
            "patiname": "Patient Name Search",
            "detail": "View Details",
            "startTotalAmt": "Beginning Total",
            "rechargeTotalAmt": "Total Recharge",
            "resumeTotalAmt": "Total Consumption",
            "remaindTotalAmt": "Ending Total",
            "memberName": "Membership Level",
            "creationTime": "Opening Date",
            "beginAmt": "Beginning",
            "chargeAmt": "Principal",
            "giveAmt": "Bonus",
            "totalAmount": "Total",
            "rechargeAmt": "Recharge",
            "resumeAmt": "Consumption",
            "endAmt": "Ending",
            "balanceStatic": "Member Balance Statistics"
        },
        "integral": {
            "patiNameSearch": "Patient Name Search",
            "isShowZero": "Points of 0 are not shown",
            "resumeTotalIntegralTotal": "Total Consumption Cumulative Points",
            "issueTotalIntegralTotal": "Total Points Issued",
            "exchangeTotalIntegralTotal": "Total Redemption Points",
            "availableTotalIntegralTotal": "Current Integral Total",
            "resumeTotalIntegral": "Consumption Accumulation Points",
            "issueTotalIntegral": "Accrued Points",
            "exchangeTotalIntegral": "Total Exchange Points",
            "availableIntegral": "Current Points"
        },
        "balanceDetail": {
            "detail": "Balance Detail",
            "creationTime": "Trading Date",
            "tradeTypeName": "Trading Type",
            "payTypeName": "Payment Method",
            "payTotalAmt": "Trading Balance",
            "principalAmt": "Trading Principal",
            "sendAmt": "Trading Bonus",
            "principalbalance": "Principal Balance",
            "sendbalance": "Bonus Balance",
            "patiName": "Patient Name",
            "doctorName": "Doctor",
            "sellerName": "Salesman",
            "chargeUserName": "Toll Collector",
            "staticDetail": "Member Balance Statistics Details"
        },
        "integralDetail": {
            "detail": "Point Detail",
            "creationTime": "Change Time",
            "changeTypeName": "Change Type",
            "exchangeName": "Exchange Items",
            "changeIntegral": "Change Points",
            "creatorUserName": "Operator",
            "staticDetail": "Points Statistics Details"
        }
    },
    "inventory": {
        "common": {
            "drugRoom": "Pharmacy",
            "label": "{name}：",
            "orderType": "Item Type",
            "buyPrice": "Purchase Subtotal",
            "substituteOrderCode": "Bar Code",
            "vendorName": "Supplier",
            "productNum": "Batch Number",
            "expiredDate": "Exp.d.",
            "buyPriceTotal": "Total Purchase Cost：",
            "sellPriceTotal": "Total Sales Amount：",
            "pleaseChoose": "Please Select",
            "voucherAbstract": "Voucher Summary",
            "operator": "Operator",
            "status": "Status",
            "chargeUnitSellTotalPrice": "Sales Subtotal",
            "saveDraftSuccess": "Save draft successfully!",
            "stockAmount": "Inventory Quantity",
            "projectName": "{name} Items",
            "varietyNum": "Number of Varieties：",
            "orderPlaceHolder": "Enter Name/Shorthand Code/Bar Code",
            "inStorageTime": "Stock-in Time",
            "product": {
                "choosed": "Selected batch number({num})",
                "noChoose": "No Batch Number Specified"
            },
            "oneMoreTips": "Please fill in at least one item!"
        },
        "outStock": {
            "placeHolder": "Name/Shorthand Code/Bar Code Search",
            "isNull": "0 is not shown in inventory",
            "isFlag": "Only show that the inventory reaches the lowest level",
            "tableTitle": "Query Items",
            "buyTotalPrice": "Total Purchase Cost: ",
            "sellTotalPrice": "Total Estimated Sales: ",
            "inventoryUpper": "Maximum Inventory Level",
            "inventoryUpperTip": "{num} projects have current inventory levels below the minimum inventory level",
            "inventoryFloor": "Minimum Inventory Level",
            "inventoryFloorTip": "{num} projects have current inventory levels higher than the inventory limit",
            "stop": "Disable",
            "costom": "Inventory",
            "recentlyCostPrice": "Recent Purchase Unit Price",
            "sellPrice": "Estimated Sales Amount",
            "exportName": "Real Time Inventory_{date}",
            "outStockName": "Real Time Inventory",
            "stockDetail": "Inventory Details ",
            "storageDate": "Out/In Date",
            "typeName": "Out/In",
            "storageTypeName": "Type",
            "storageNum": "Bill Number",
            "unitCot": "Quantity"
        },
        "checkWarehouse": {
            "checkWarehouseName": "Inventory Operation",
            "stockCheck": "Pharmacy Inventory",
            "tempCheck": "Temporary Inventory",
            "createdStartDate": "Creation Date",
            "drugRoomCheck": "Pharmacy Inventory",
            "checkRange": "Inventory Scope",
            "orderType": "Item Category",
            "dosageFormMainType": "Dosage Form Subclassification",
            "batchCheck": "Inventory by batch",
            "checkNum": "Inventory Number",
            "projectType": "Item Category",
            "placeHolder": "Item Name/Barcode/Shorthand Code Search",
            "isHideZero": "0 is not shown in inventory",
            "checkFinish": "Inventory completion",
            "checkFinish_1": "Complete Inventory!",
            "import": "Import",
            "checkProject": "Inventory Item",
            "stockAmount": "System Inventory",
            "checkAmount": "Inventory Count",
            "checkId": "Inventory ID",
            "projectCode": "Item Coding",
            "isSplit": "Disassemble or not",
            "checkOutpatient": "Take inventory of outpatient inventory",
            "checkOutpatientUnit": "Take inventory of outpatient inventory units",
            "checkSplit": "Take inventory of dismantled inventory",
            "checkSplitUnit": "Take inventory and dismantle inventory units",
            "importFail": "Import failure!"
        },
        "wareHouse": {
            "in": {
                "inStorage": "Stock-in",
                "inStorageName": "Stock-in Management",
                "inStorageType": "Stock-in Type",
                "inStorageDate": "Stock-in Date",
                "placeHolder": "Stock-in Number / Peer Number / Item Name Search",
                "inStorageRange": "Stock-in Scope",
                "inStorageNum": "Stock-in Number",
                "inStorageNumTong": "Peer Number",
                "inStorageHouse": "Stock-in Pharmacy",
                "inStorageVariety": "Variety Quantity",
                "inStorageNumNow": "Quantity",
                "unit": "Unit",
                "buyPrice": "Purchase Price",
                "sellPrice": "Unit Sales Price",
                "profitRate": "Profit Rate",
                "productDate": "Mfg.d.",
                "inStorageSuccess": "Confirm successful storage!",
                "manualEntry": "Manual Entry",
                "importExcel": "Import accompanying document with shipment Excel",
                "chooseExcel": "Select accompanying document with shipment Excel",
                "importExcelTips": "Please make sure that the column heading of accompanying document with shipment Excel corresponds to the system title accurately",
                "excelTableSet": {
                    "name": "WangZhenyun System Titles",
                    "excelName": "The column heading of accompanying document with shipment Excel",
                    "example": "First Line Data Example"
                },
                "importErrorTips": "Import failed, please re-select the file!"
            },
            "out": {
                "outStorage": "Stock-out",
                "outStorageName": "Stock-out Management",
                "outStorageType": "Stock-out Type",
                "outStorageDate": "Stock-out Date",
                "placeHolder": "Stock-out Number / Item Name Search",
                "outStorageRange": "Stock-out Scope",
                "stockAmount": "Inventory Quantity",
                "outStorageNum": "Stock-out Number",
                "outStorageHouse": "Stock-out Pharmacy",
                "outStorageNumNow": "Stock-out Quantity",
                "moreStockAmountTip": "The quantity of some medical orders sent out exceeds the quantity of existing inventory, please adjust!",
                "outStorageSuccess": "Confirm delivery success!"
            },
            "edit": {
                "saveDraft": "Save Draft",
                "confirm": "Confirm {name}",
                "changeSellPrice": "Change Selling Price",
                "nullTips": "Please fill out the required fields!",
                "zeroTips": "The quantity of some items is 0!",
                "noMatchTips": "Unmatched items exist and cannot be saved!",
                "noEditTips": "There is a related stock-out record, can not be edited!"
            }
        },
        "supplier": {
            "searchPlaceholder": "Name Search",
            "tableTop": "Supplier",
            "totalCount": "Total",
            "editTitle": "Supplier Maintenance",
            "vendorName": "Supplier Name",
            "pyCode": "Shorthand Code",
            "sort": "Sort",
            "contactUserName": "Contact Person",
            "contactPhoneNumber": "Telephone",
            "status": "Status",
            "column": {
                "vendorName": "Supplier Name",
                "sort": "Sort",
                "startStop": "Enable/Disable"
            },
            "modalTitle": "Confirm {t}",
            "modalContent": "Confirm {t} 【{name}】"
        }
    },
    "statistical": {
        "operationstatistical": {
            "overView": "Overview",
            "operatingIndex": "Operating Index",
            "ordersell": "Charge Item Statistics",
            "opdFeeSummaryReportByUser": "Toll Collector Statistics",
            "opdFeeSummaryReport": "Charge Detail",
            "opdFeeSummaryReportByMonth": "Monthly Summary",
            "opdFeeSummaryReportByDay": "Daily Summary",
            "opdFeeSummaryReportByDoctor": "Doctor Statistics",
            "opdFeeSummaryReportByPharmacist": "Pharmacist Statistics",
            "opdRegisterInfoDetail": "Outpatient Log",
            "treatmentExecution": "Healing Execution Statistics",
            "age": "Y"
        },
        "storagestatistical": {
            "inStorage": "Stock-in Statistics",
            "outStorage": "Stock-out Statistics",
            "storageWarning": "Expiration Warning",
            "storageUnsalablWarning": "Unsalable Warning",
            "vendorStorage": "Supply Statistics",
            "inOutStorage": "Stock-in And Stock-out Details",
            "purchaseSaleStock": "Inventory Report"
        },
        "overView": {
            "alertTip": "Funds Received = Registered Income + Outpatient Revenue + Retail Revenue",
            "chargeSellPriceAmt": "Actual Received",
            "chargeBuyPriceAmt": "Total Cost",
            "profitAmount": "Total Gross",
            "profitRate": "Gross Profit Margin",
            "returnAmt": "Total Refund",
            "registerSellPriceAmt": "Registered Income",
            "opdSellPriceAmt": "Outpatient Income",
            "pricechargeSellPriceAmt": "Retail Income",
            "memberRechargeAmount": "Member Recharge",
            "cardRecharge": "Card Recharge",
            "payTypeTip": "Total = Funds Received + Member Recharge",
            "payTotalAmt": "Total Payment Amount",
            "filterTypeDay": "Day",
            "filterTypeMonth": "Month",
            "filterTypeYear": "Year",
            "revenueStatistics": "Turnover Statistics",
            "revenueAmt": "Turnover",
            "visitsNum": "Outpatient Person Times",
            "payType": "Payment Method",
            "payType_1": "Cash",
            "payType_2": "Agricultural Bank",
            "payType_3": "Naoby Bank",
            "payType_4": "Alipay",
            "payType_5": "Wechat",
            "payType_6": "Member",
            "payType_7": "JDB",
            "diagnTop10": "TOP10 Disease Diagnosis",
            "ageStatistics": "Statistics Of Visits By Age Group",
            "timeGroupStatistics": "Seeing The People In The Different Periods",
            "statisticsLoadingTip": "Statistics data is loading"
        },
        "ordersell": {
            "orderType": "Item Type",
            "chTradeName": "Item Name Search",
            "alertTip": "There are prescriptions waiting to be issued, which may affect the cost calculation. Please deliver the prescriptions in time!",
            "chargeProject": "Charge Item",
            "exportFileName": "Export Data - Charge Item Statistics"
        },
        "orderselldetail": {
            "pageTitle": "Prescription Details",
            "mainIdentity": "Visiting Status",
            "nameSearch": "Patient Name / Doctor Name Search",
            "alertTip": "There are prescriptions waiting to be issued, which may affect the cost calculation. Please deliver the prescriptions in time!",
            "exportTitle": "Export Data - Charge Item Statistics - Prescription Details"
        },
        "opdfeesummaryreportbyuser": {
            "chargeDetailByDay": "Details Of Outpatient Collection Date",
            "exportTitle": "Export Data - Toll Collector Statistics"
        },
        "opdfeesummaryreport": {
            "mainIdentity": "Visit Identity",
            "nameSearch": "Doctor Name / Patient Name / Item Name Search",
            "alertTip": "The actual received is calculated using the weighted average algorithm, rounded to two decimal places",
            "exportTitle": "Export Data - Prescription Details"
        },
        "opdfeesummaryreportbydoctor": {
            "doctorUser": "Attending Doctor",
            "section": "Department",
            "isHideZero": "The total cost and total sales are both 0",
            "alertTip": "There are prescriptions waiting to be issued, which may affect the cost calculation. Please deliver the prescriptions in time!",
            "exportTitle": "Export Data - Doctor Statistics"
        },
        "inStorage": {
            "exportTitle": "Export Data - Stock-in Statistics"
        },
        "outStorage": {
            "exportTitle": "Export Data - Stock-out Statistics"
        },
        "storageWarning": {
            "pharmacy": "Pharmacy",
            "expireDate": "Expiration Days",
            "expired": "Expired"
        },
        "storageUnsalablWarning": {
            "unSoleDays": "Unsalable Days",
            "days": "Days"
        },
        "purchaseSaleStock": {
            "drugType": "Item Type",
            "chScientificName": "Item Name Search",
            "stopUse": "Disable",
            "exportTitle": "Export Data - Inventory Report"
        },
        "commonTableSet": {
            "totalMedicalAmt": "Total Receivables",
            "discountAmt": "Discount",
            "artificialDiscountAmt": "Bargain",
            "totalPayableMinusAmt": "Deficit",
            "returnAmt": "Refund",
            "totalReceiveAmt": "Total Actual Received",
            "payType": "Payment Method",
            "weChatFee": "Wechat",
            "aliPayFee": "Alipay",
            "mergeFee": "Aggregate Payment",
            "cashFee": "Cash",
            "cardFee": "Member",
            "ybCardFee": "Medicare Card",
            "numerRMBFee": "Digital",
            "totalFee": "Subtotal",
            "yb": "医保",
            "ybMedicarePayAmt": "统筹基金(元)",
            "ybAccountPayAmt": "个人账户(元)",
            "projectType": "Item Type",
            "prescriptionDetails": "Charge Detail",
            "receiptsAmt": "Total Actual Received",
            "chargeUnitBuyTotalPriceAmount": "Total Cost",
            "profitAmount": "Total Gross",
            "profitRate": "Gross Profit Margin",
            "creationTime": "Charge Time",
            "creatorUserName": "Collect/Refund",
            "chargeStatusName": "Charge Status",
            "storageTypeName": "Dispensing Status",
            "mainIdentityName": "Consultation Identity",
            "applyDoctorName": "Attending Doctor",
            "patientName": "Patient Name",
            "patientName_1": "Patient Name",
            "orderTypeName": "Item Type",
            "storageType": "Stock-in Type",
            "roomName": "Pharmacy Name",
            "orderTypeCount": "Charging Items Varieties",
            "chargeUnitAmt": "Charging Items Quantity",
            "chargeUnitBuyTotalPrice": "Purchase Subtotal",
            "chargeUnitSellTotalPrice": "Sales Subtotal",
            "storageTypeExport": "Stock-out Type",
            "pharmacy": "Pharmacy",
            "productNum": "Batch Number",
            "expiryDate": "Exp.d.",
            "unitCot": "Inventory",
            "unSoleDays": "Unsalable Days",
            "beginDate": "Beginning",
            "endDate": "Ending",
            "importStore": "Stock-in",
            "exportStore": "Stock-out",
            "departmentName": "Department",
            "cot": "Patient Attendance",
            "projectTotalAmt": "Total Items",
            "totalAmount": "Accounts Receivable",
            "totalReceiveAmount": "Actual Received",
            "costTotalAmount": "Cost Subtotal",
            "profitAmt": "Gross Subtotal",
            "registerFeeAmount": "Consultation Fee",
            "westernFeeAmount": "Western Drug Fee",
            "tranditionalMedicineFeeAmount": "Chinese Patent Drug Fee",
            "chineseFerbFeeAmount": "Chinese Herbal Drug Fee",
            "sanitationFeeAmount": "Consumable Fee",
            "treatFeeAmount": "Treatment Fee",
            "checkFeeAmount": "Examination Fee",
            "inspectFeeAmount": "Laboratory Fee",
            "surgeryFeeAmount": "Surgery Fee",
            "infusionFeeAmount": "Infusion Additional Items Fee"
        }
    },
    "templateManager": {
        "tab_section": "Department Prescription Template",
        "tab_personal": "Personal Prescription Template",
        "filter": {
            "section": "Department",
            "packageName": "Template Name Search"
        },
        "addBtn_1": "Add Department Template",
        "addBtn_2": "Add Doctor Template",
        "edit": "Edit",
        "column": {
            "sectionName": "Department",
            "packageName": "Template Name"
        },
        "delModal": {
            "title": "Confirm Deletion",
            "content": "Confirm to delete?"
        },
        "editModal": {
            "title_add": "Add Template",
            "title_edit": "Edit Template",
            "packageName": "Template Name"
        }
    },
    "workforce": {
        "template": {
            "workTimeBtn": "Class Management",
            "allSection": "All Department",
            "viewBtn": "View",
            "pauseBtn": "Paste",
            "writeBtn": "Scheduling",
            "popupModal": {
                "title": "Scheduling Information",
                "copyBtn": "Copy",
                "timeInterval": "Appointment Interval {t} minutes, {n} appointments can be made."
            },
            "addForm": {
                "doctorLevel": "Consultation Level",
                "section": "Department",
                "room": "Consultation Room",
                "interval": "Appointment Interval",
                "time": "minutes, ",
                "person": " appointments can be made."
            },
            "workTimeModal": {
                "addBtn": "Add",
                "title": "Class Information",
                "name": "Class Name",
                "beginTime": "Start Time",
                "endTime": "End Time"
            },
            "msg": {
                "copyFail": "The current scheduling information is empty. Unable to copy",
                "copySuccess": "Copy Successfully!",
                "pauseSuccess": "Paste Successfully!",
                "timeRange": "The schedule time overlaps, please choose again",
                "timeEquality": "Start time cannot be equal to end time"
            },
            "delModal": {
                "title": "Confirm Deletion",
                "content": "Confirm to delete?"
            }
        },
        "mananger": {
            "filter": {
                "date": [
                    "Consultation Date",
                    "End Date"
                ],
                "name": "Doctor Name Search"
            },
            "addBtn": "Add Scheduling",
            "workModal": {
                "title": "Scheduling Information",
                "visitDate": "Consultation Date",
                "doctorUser": "Doctor",
                "section": "Consultation Department",
                "room": "Consultation Room",
                "doctorLevel": "Consultation Level",
                "interval": "Appointment Interval",
                "time": "minutes, ",
                "person": " appointments can be made."
            },
            "copyBtn": "Copy Scheduling",
            "copyModal": {
                "tip": "Copy the scheduling template",
                "checked": "Select All",
                "date": "Schedule Date",
                "allSection": "All"
            },
            "exportName": "Scheduling management -{date}",
            "stopReason": {
                "title": "Please Enter【{name}】Reason For Deactivation",
                "reason": "Deactivation Reason"
            },
            "column": {
                "visitDate": "Consultation Date",
                "workName": "Class",
                "sectionName": "Department",
                "roomName": "Consultation Room",
                "doctorUserName": "Doctor",
                "doctorLevelName": "Consultation Level",
                "timeinterval": "Appointment Interval (Minutes)",
                "stayReason": "Discontinuation Reason"
            },
            "delModal": {
                "title": "Confirm Deletion",
                "content": "Confirm to delete?"
            },
            "startModal": {
                "title": "Confirm Enable",
                "content": "Confirm Enable 【{name}】?"
            },
            "msg": {
                "actSuccess": "Operation successful!",
                "timeRange": "The schedule time overlaps, please choose again",
                "lengthZero": "Please add the schedule time",
                "copyLengthZero": "Please choose the scheduling doctor!",
                "copySuccess": "Copy Successfully!"
            }
        }
    },
    "formCreation": {
        "formCreation": "Form Creation",
        "placeHolder": "Name Search",
        "checkAll": "Select All"
    },
    "modelTable": {
        "refunded": "Refunded",
        "partRefund": "Rebate",
        "returnRatio": "{n} Doses Returned",
        "rebateText": "{name} returned {unit}",
        "charged": "Charged",
        "exist": "Already Exists!",
        "signDel": "Received, please delete individually!",
        "signDelSingle": "【{name}】signed in, Undeletable!",
        "signChangeSingle": "【{name}】signed in,non-switchable！",
        "remarkSet": "Notes Setting",
        "placeHolder": "Enter Name Or Shorthand Code",
        "stock": "Inventory",
        "drugs": "Drugs",
        "consumables": "Consumables",
        "unmatched": "Unmatched",
        "addDrug": "Add Drug",
        "addConsumables": "Add Consumables"
    },
    "pianYuCom": {
        "common": "In common use"
    },
    "payModel": {
        "printConfig": {
            "receiptTypeName": "Receipt Type",
            "isPreview": "Preview",
            "printNumers": "Number",
            "registeredReceipt": "Charge receipt",
            "feeReceipt": "Charge receipt",
            "invoice": "医疗收费发票",
            "longDispenseList": "Long-term Medical Order Prescription",
            "shortDispenseList": "Temporary Medical Order Prescription",
            "giveDrugList": "Print of Drug Administration List"
        }
    },
    "tableCom": {
        "serialNumber": "Sequence",
        "dateChoose": "Please Select"
    },
    "tipsCom": {
        "confirm": "OK"
    },
    "prescriptionTable": {
        "medicalRecords": {
            "soapChiefComplaint": "Chief Complaint",
            "soapIllnessHistory": "Present History",
            "soapPreviousHistory": "Past History",
            "soapFamilyHistory": "Family History",
            "soapPhysicalExamination": "Physical Examination",
            "soapLookSmellFeel": "Sight, Smell, Palpation, Diagnosis",
            "soapAuxiliaryExamination": "Auxiliary Examination",
            "opdDiagnosis": "Diagnosis",
            "opdDiscriminate": "Syndrome Differentiation",
            "opdTreatment": "Therapy",
            "soapTreatmentAdvice": "Treatment Advice",
            "attachments": "Attachment",
            "attachmentsPlaceholder": "Upload {label}",
            "examination": {
                "tem": "T",
                "pulse": "°C, P",
                "breathe": "times / min, R",
                "heartRate": "times / min, HR",
                "heartRateUnit": "times / min, ",
                "bloodPressure": "BP",
                "diastolicPressure": "BP",
                "systolicPressure": "",
                "end": "mmHg;"
            },
            "requiredMsg": "Please select at least one diagnosis!",
            "bloodMsg": "Please enter the blood pressure according to the format!",
            "bloodTip": {
                "title": "Blood Pressure Value Example",
                "p_1": "Blood pressure consists of diastolic/systolic pressure, for example: If blood pressure is ",
                "p_2": "mmHg, it should be interpreted as diastolic 80mmHg / systolic 120mmHg."
            }
        },
        "westernMedicine": {
            "title": "Drug Prescription {index}",
            "addPlaceholder": "Enter Name Or Shorthand Code",
            "addBtn": "Add",
            "requiredMsg": "The dosage, frequency, route, days and unit of western drug/chinese patent drug cannot be empty"
        },
        "chineseHerbal": {
            "title": "Chinese Herbal Drug Prescription {i}",
            "readTitleRight": {
                "name": "{name}, ",
                "ratio": "{n} Doses, ",
                "length": "{n} pills, "
            },
            "drugForm": "Dosage Form Subclassification",
            "usage": "Medication method",
            "decoctionMethod": "Decoctions",
            "decoctionMethodSetBtn": "Decoctions Setting",
            "addBtn": "Add",
            "requiredMsg": "Chinese herbal drug dose cannot be empty",
            "requiredMsg_2": "Chinese herbal drug processing can not be empty",
            "requiredMsg_3": "The processing cost of chinese herbal drug can not be empty"
        },
        "injectionView": {
            "eisaiTitle": "Additional Item",
            "title": "Injection Group {i}",
            "extra": "{freq}, {usage}, {days} Days",
            "freq": "Frequency",
            "usage": "Usage",
            "days": "Days",
            "daysUnit": "Days",
            "skin": "Skin Test",
            "addBtn": "Add",
            "requiredMsg": "The dose, frequency, route, days, and unit of the drug infusion cannot be empty"
        },
        "inspectionView": {
            "requiredMsg": "The units and total of laboratory and examination cannot be empty"
        },
        "disposalView": {
            "requiredMsg": "The units and total of treatment cannot be empty"
        },
        "operationView": {
            "requiredMsg": "The units and total of operation cannot be empty"
        }
    },
    "appointmentSign": {
        "title": "Appointment Sign In",
        "tel": "",
        "signBtn": "Sign In",
        "column": {
            "time": "Time",
            "doctor": "Doctor"
        }
    },
    "caseInfoCard": {
        "retail": "零售",
        "unpaid": "No Charge",
        "returnText": "退",
        "chineseExtra": " Prescription",
        "injectionView": "-Additional Item",
        "injectionView_2": "",
        "soapTemperature": "T {n}°C, ",
        "soapPulse": "P {n} times / min, ",
        "soapBreathe": "R {n} times / min, ",
        "soapHeartRate": "HR {n} times / min,  ",
        "soapDiastolicSystolicPressure": "BP {d}/{s} mmHg;"
    },
    "checkboxTabs": {
        "checkedAll": "Select All"
    },
    "customArco": {
        "inputTriggerTag": {
            "tip": "For Medicare billing, use standard diagnostic names",
            "placeH": "Add {name}",
            "common": "In common use",
            "diagnosis": "Diagnosis ",
            "discriminate": "Syndrome Differentiation ",
            "treatment": "Therapy ",
            "delModal": {
                "title": "Confirm Deletion",
                "content": "Confirm delete {name}?"
            },
            "isInclude": "{name} already exists!"
        }
    },
    "fileIcon": {
        "delTitle": "Confirm Deletion",
        "delContent": "Confirm to delete?"
    },
    "caseInfoView": {
        "stopUnCopy": "Disabled, cannot copy!",
        "delUnCopy": "Deleted, cannot copy!"
    },
    "printModal": {
        "printer": "Select printer",
        "direction_1": "Vertical",
        "direction_2": "Crosswise",
        "count": "Copies",
        "offset": {
            "top": "Upward shift",
            "left": "Left shift"
        },
        "margin": {
            "top": "Top margin",
            "bottom": "Bottom margin",
            "left": "Left margin",
            "right": "Right margin"
        },
        "content": "Print Content"
    },
    "stackModal": {
        "select": "Classification",
        "select_1": "Department",
        "select_2": "Personal",
        "packageName": "Template Name",
        "tipTitle": "Tips",
        "tipContent": "Please modify the template before use!",
        "unitChange": "【{name}】的单位发生调整；"
    },
    "patientBasicModal": {
        "add": "【Add】",
        "edit": "【Edit】",
        "infoTitle_1": "Basic Information",
        "infoTitle_1_1": "Tag: ",
        "patiname": "Name",
        "birthdatetime": "Date Of Birth",
        "sex": "Gender",
        "age": "Age",
        "idTypeName": "ID Type",
        "idCardNo": "ID NO.",
        "comingWayName": "Access To The Hospital",
        "tel": "Mobile",
        "isWillingTel": "No cellphone number provided",
        "healthInsuranceCard": "Medical Insurance Card Number",
        "infoTitle_2": "Detailed Information",
        "patientFrom": "Patient Origin",
        "patientFromMark": "Patient Origin Notes",
        "jobName": "Occupation",
        "folkName": "Nation",
        "marriageName": "Matrimony",
        "contactPeople": "Contact Person",
        "relationShip": "Relationship",
        "contactTel": "Contact Telephone",
        "address": "Present Address",
        "patientMemo": "Notes",
        "infoTitle_3": "Allergy History And Major Medical History",
        "allergyItem": "Allergy History",
        "diseaseItem": "Major Medical History"
    },
    "patientTag": {
        "tagTitle_1": "文字标签",
        "tagTitle_2": "表情标签",
        "settingTagTitle": "文字标签设置"
    },
    "patientTitle": {
        "tel": ""
    },
    "payDiscount": {
        "title": "Payment Preference",
        "memberLabel": "Member",
        "memberTel": "Member Telephone",
        "alertTitle": "Discount",
        "notEdit_1": "Doctors do not participate in member benefits after bargaining.",
        "notEdit_2": "If a fee item participates in multiple promotional activities, the most favorable discount will be taken by default",
        "total": "Discount price total",
        "totalUnit": ""
    },
    "payModal": {
        "anonymity": "Anonymity",
        "tel": "",
        "ybTitle": {
            "fund": "统筹基金",
            "siPersonal": "个人账户",
            "cash": "现金",
            "noNeed": "医保外"
        },
        "ybSuffix": "{l}支付(元)",
        "memberQuit": {
            "recharge": "Principal Balance",
            "send": "Bonus Balance"
        },
        "bargain": "Bargain",
        "resetBtn": "Recover",
        "surplus": "Accounts Receivable",
        "chosPayEmpty": "Please Select Payment Method",
        "overflowMember": "The current amount exceeds the premium balance. Please change it",
        "surplusMoney": "Available balance",
        "quitEmpty": "Please select a return method",
        "quitReason": "{t} Reason",
        "quitLabel": "{l}",
        "quitSendAmt": "Gift Deduction",
        "refundReason": "Reason For Cancellation",
        "seller": "Salesman",
        "invoice": {
            "num": "发票号码",
            "sn": "当前发票号码"
        },
        "dispense": "Simultaneous Dispensing",
        "printXp": "Print Receipt",
        "okTip_1": "Current actual received exceeds accounts receivable, please modify",
        "okTip_2": "The current actual received is insufficient, please modify",
        "payMode": {
            "wx": "Wechat",
            "zfb": "Alipay",
            "jh": "Agricultural Bank",
            "xj": "Cash",
            "hy": "Member",
            "yb": "Naoby Bank",
            "szRMB": "JDB"
        },
        "maxPayLimit": "Most support three different payment!",
        "successMsg": {
            "regis": "Registration Successfully!",
            "sign": "Sign In Successfully!",
            "collectfee": "Charge Successfully!",
            "memberFee": "Recharge Successfully!",
            "quit": "Refund Successfully!"
        },
        "okMsg": {
            "member": "Insufficient member balance!",
            "principal": "Please enter the return amount!",
            "biggerPrincipal": "The return amount cannot be greater than the principal balance!",
            "biggerSend": "The bonus deduction cannot be greater than the bonus balance!"
        }
    },
    "needClient": {
        "title": "Download Client",
        "download": "Download"
    },
    "verifyCationCode": {
        "title": "Please Complete Graphic Verification",
        "input": "Graphic Verification Code",
        "refresh": "Refresh"
    },
    "settingModal": {
        "defaultName": "Decoctions",
        "add": "Add"
    },
    "registerSceneModal": {
        "patiname": "Name",
        "mainIdentity": "Consultation Category",
        "doctorLevel": "Consultation Level",
        "payAmt": "Consultation Price",
        "disAmt": "Payment Preference",
        "changeDis": "Modify Payment Preferences",
        "pretherapy": "Prediagnosis",
        "sign": "Sign In",
        "regis": "Registration",
        "booking": "Appointment Sign In"
    },
    "autoUpdate": {
        "title": "Update prompt",
        "content": "The version has been updated, please click the button to update"
    },
    "exportExcel": {
        "empty": "No Exported Data!"
    },
    "performance": {
        "performancemanage": {
            "title": "Commission Scheme",
            "searchPlaceholder": "Commission Scheme Name Search",
            "addBtnTxt": "Add Commission Scheme",
            "commissionSchemesName": "Commission Scheme Name",
            "userInfo": "Commission Scheme Uers",
            "commissionSchemesType": "Commission Scheme Type",
            "computerule": "Commission Calculation Rule：",
            "creationTime": "Creation Time",
            "delTitle": "Confirm Deletion",
            "delContent": "Confirm to delete?",
            "delSuccess": "Deleted Successfully!"
        },
        "performancemanageForm": {
            "addBtnTxt": "Add Commission Scheme",
            "editBtnTxt": "Edit Commission Scheme",
            "commissionSchemesName": "Commission Scheme Name",
            "userInfo": "Commission Scheme Uers",
            "itemInfo": "Commission Scheme Items",
            "commissionSchemesType": "Commission Scheme Type",
            "item": {
                "orderTypeName": "Item Type",
                "price": "Selling Price",
                "coefficient": "Commission Coefficient",
                "commission": "Commission",
                "proportion": "Proportion",
                "fixed": "Fixed"
            }
        },
        "performancereport": {
            "title": "Commission Report",
            "searchPlaceholder": "Commission Report Name Search",
            "searchInfo": {
                "preformanceList": "Commission Scheme List"
            },
            "searchtable": {
                "userName": "User Name",
                "performanceManagementName": "Scheme",
                "total": "Total",
                "fixed": "Fixed",
                "chinesePatentDrug": "Chinese Patent Drug",
                "westernDrug": "Western Drug",
                "chineseHerbalDrug": "Chinese Herbal Drug",
                "consumable": "Consumable",
                "laboratory": "Laboratory",
                "examination": "Examination",
                "treatment": "Treatment",
                "surgery": "Surgery",
                "consultationFee": "Consultation Fee",
                "infusionAddition": "Infusion Additional",
                "inpatientItem": "Inpatient Item"
            },
            "exportFileName": "Commission Report"
        },
        "tabsList": {
            "performancemanage": "Commission Scheme",
            "performancereport": "Commission Report"
        },
        "common": {
            "edit": "Edit",
            "delete": "Delete"
        }
    },
    "common": {
        "copyright": "Copyright © Nanjing Ting Wang Technology Co., LTD. All rights reserved",
        "pwdTip": "The password format is a combination of 6 to 20 English letters, numbers, and characters",
        "cancel": "Cancel",
        "save": "Save",
        "ok": "OK",
        "close": "Close",
        "edit": "Edit",
        "unlimited": "All",
        "openUse": "Enable",
        "stopUse": "Disable",
        "add": "Add",
        "amend": "Edit",
        "delete": "Delete",
        "success": "Successfully!",
        "editSuccess": "Edit Successfully!",
        "openUseSuccess": "Enabled Successfully!",
        "stopUseSuccess": "Disabled Successfully!",
        "addSuccess": "Added Successfully!",
        "deleteSuccess": "Deleted Successfully!",
        "amendSuccess": "Changed Successfully!",
        "operationSuccess": "Operated Successfully!",
        "fail": "failed!",
        "operation": "Control",
        "yes": "Yes",
        "no": "No",
        "mainIdentityLabel": "Consultation Identity",
        "mobile": "Phone number",
        "telephone": "Telephone",
        "idNum": "Identity Card Number",
        "birthday": "Date Of Birth",
        "name": "Name",
        "gender": "Gender",
        "male": "male",
        "female": "female",
        "section": "Department",
        "memo": "Notes",
        "pyCode": "Shorthand Code",
        "refresh": "Refresh",
        "tipTitle": "Tips",
        "tipTitle_2": "Warnning",
        "clearScreen": "Clear Screen",
        "readIdCard": "读身份证",
        "readMedicalCard": "读医保卡",
        "basicTitle": "Patient Information",
        "wareHouse": "Pharmacy",
        "startDate": "Start Date",
        "endDate": "End Date",
        "pricePrefix": "₭",
        "back": "Return",
        "ratioUnit": "Doses",
        "export": "Export",
        "print": "Print",
        "all": "All",
        "alertTips": "Total actual received = Total receivables - Discount - Negotiated price - Deficit - Refund",
        "checkDetail": "View Details",
        "day": "Today",
        "week": "Week",
        "month": "Month",
        "year": "Year",
        "check": "View",
        "changePatiName_1": "Patient's original name ",
        "changePatiName_2": " is now changed to ",
        "changePatiName_3": ". Confirm modification?",
        "saveSuccessed": "Save Successfully!",
        "saveFailed": "Save failed!",
        "tollCollector": "Toll Collector",
        "refundOfficer": "Refund Clerk",
        "feesProcessedName": "Contract Processing",
        "settingBtn": "Setting",
        "birth_year": "Year",
        "birth_year_simple": "Y",
        "birth_month": "Month",
        "birth_month_simple": "M",
        "birth_day": "Day",
        "birth_day_simple": "D",
        "ageTips": "Age can be entered directly",
        "repeatRegis": "There is already a registration record for this doctor in this time slot.Continue?",
        "rangeDateSplit": " — ",
        "uploadFileBtn": "Upload {label}",
        "uploadBlack": "Files with the .exe extension cannot be uploaded!",
        "amountPrefix": "₭ ",
        "diastolicPressure": "Diastolic Blood Pressure",
        "systolicPressure": "Systolic Blood Pressure",
        "tagName": "Tag"
    },
    "commonTableSet": {
        "chScientificName": "Item Name",
        "drugSpec": "Specification",
        "manufacture": "Manufacturer",
        "price": "Price",
        "priceY": "Price",
        "amount": "Amount",
        "totalAmount": "Expense",
        "dosageName": "Dosage",
        "freqName": "Frequency",
        "usageName": "Usage",
        "usageName_2": "Usage",
        "tqty": "Total",
        "quantity": "Quantity",
        "number": "Number",
        "unit": "Unit",
        "days": "Days",
        "region": "Part",
        "operationNumber": "Knife Edge",
        "memo": "Notes",
        "action": "Control",
        "viewDetails": "View Details",
        "receivableAmount": "Receivable Subtotal",
        "receiptsAmt": "Actual Received",
        "costAmount": "Cost Subtotal",
        "profitAmount": "Gross Subtotal",
        "profitRate": "Gross Profit Margin"
    },
    "commonPrint": {
        "size_A4": "A4",
        "size_A5": "A5",
        "size_XP": "小票",
        "size_PT": "瓶贴",
        "size_FP": "发票",
        "settingTitle": "【Emma Watson】Prediagnosis",
        "setting": "Print Setting",
        "printingName": "Printer",
        "pageSize": "Paper Size",
        "printNumers": "Number",
        "invoiceType": "发票类型",
        "invoiceSetting": "发票代码",
        "invoiceNumber": "发票号码",
        "unInstallPrint": "You have not installed the print component",
        "install": "Install"
    },
    "prescription": {
        "medicalRecords": "Medical Record",
        "westernMedicine": "Drug",
        "chineseHerbal": "Chinese Herbal Drug",
        "injectionView": "Injection",
        "inspectionView": "Laboratory and Examination",
        "disposalView": "Treatment",
        "operationView": "Surgery"
    },
    "month": {
        "Jan": "Jan",
        "Feb": "Feb",
        "Mar": "Mar",
        "Apr": "Apr",
        "May": "May",
        "Jun": "Jun",
        "Jul": "Jul",
        "Aug": "Aug",
        "Sep": "Sep",
        "Oct": "Oct",
        "Nov": "Nov",
        "Dec": "Dec"
    },
    "otherMsg": {
        "loginSuccess": "Login successful!",
        "noMenu": "The current account has no menu, please contact {name} responsible person!",
        "serviceLoading": "System loading, please wait!",
        "serviceError": "Server connection failed!",
        "loginExpired": "Login has expired, please login again!",
        "tabTitleExtra": "Wang Zhen Yun",
        "fileMaxSize": "File size cannot exceed 1M!"
    },
    "partModel": {
        "checkAll": "Select All",
        "edit_1": "{num} doses in total，",
        "edit_2": "{num} returnable doses，",
        "returnUnit": " doses return",
        "unit": "doses",
        "quantityUnit": "* {num} doses",
        "chooseAmt": "Total Selected Item：",
        "actualReturn": "Actual Return：",
        "returnDrug": "Confirm return",
        "returnDrugTip": "Confirm the return?"
    },
    "returnInfo": {
        "returnedTitle": "Refund",
        "partTableSet": {
            "status": "Status",
            "backAccount": "Returnable",
            "totalAmount": "Price",
            "receiptsAmt": "Actual Received"
        }
    },
    "inpatientPharmacy": {
        "medicineDispense": {
            "tab_1": "Long-term Medical Orders",
            "tab_2": "Temporary Medical Orders",
            "placeHolderList": {
                "pharmacy": "Pharmacy",
                "ward": "Nursing Station",
                "drugDate": "Drug Date",
                "bedNo": "Bed No.",
                "startDate": "Administration Date",
                "endDate": "End Date",
                "queryText": "File No. Search"
            },
            "printBtn": {
                "name": "List Printing",
                "list_1": "Print The List",
                "list_2": "Print Settings",
                "reprint": "Reprint List",
                "print": "Print",
                "startPrinting": "Start Printing",
                "endPrinting": "End Printing"
            },
            "checkAll": "Select all",
            "tableSet": {
                "medicalOrdersName": "Medical Orders Name",
                "specification": "Specification",
                "dosage": "Dosage",
                "frequency": "Frequency",
                "usage": "Usage",
                "tqty": "Total",
                "closingTime": "Closing Time",
                "startTime": "Start Time",
                "expirationTime": "Expiration Time",
                "changeStatus": "Change Status",
                "invalidatePrescriptionNo": "Invalidate Prescription No."
            },
            "prescriptionNo": "Prescription No.: {num}",
            "inpatientDepartment": "Inpatient Department: {name}",
            "attendingDoctor": "Attending Doctor: {name}",
            "admissionTime": "Admission Time: {time}",
            "diagnosis": "Diagnosis: {name}",
            "allergicHistory": "Allergic History: {name}",
            "majorMedicalHistory": "Major Medical History: {name}",
            "reprintList": "Reprint List",
            "printTip": "Please select at least one of the list to print!"
        },
        "refundableDrugsList": {
            "startDate": "Start Date",
            "endDate": "End Date",
            "printBtn": "Printing",
            "tableSet": {
                "fileNo": "File No.",
                "name": "Name",
                "bedNo": "Bed No.",
                "medicalOrdersNo": "Medical Orders No.",
                "drugWithdrawalAmount": "Drug Withdrawal Amount",
                "unit": "Unit",
                "drugWithdrawalDoctor": "Drug Withdrawal Doctor",
                "medicalOrdersType": "Medical Orders Type"
            }
        },
        "returnMedicine": {
            "tab_1": "Check and Receive Withdrawal Drug",
            "tab_2": "Withdrawn Drug",
            "confirm": "Confirm",
            "export": "Export",
            "tableSet": {
                "fileNo": "File No.",
                "name": "Name",
                "bedNo": "Bed No.",
                "MedicalOrderName": "Medical Order Name",
                "withdrawalAmount": "Withdrawal Amount",
                "actualWithdrawalAmount": "Actual Withdrawal Amount",
                "unit": "Unit",
                "doctor": "Doctor",
                "MedicalOrderType": "Medical Order Type",
                "exportName": "{name}-{date}"
            }
        },
        "sendConfirm": {
            "medicalOrdersType": "Medical Orders Type",
            "dispensingStatus": "Dispensing Status",
            "confirmBtn": "Confirm Dispensing",
            "cancelBtn": "Cancel Dispensing",
            "tableSet": {
                "prescriptionNo": "Prescription No.",
                "specification": "Specification",
                "dispensingStatus": "Dispensing Status"
            }
        }
    },
    "nursingSystem": {
        "manage": {
            "status": "Status",
            "queryText": "Patient Name / File No. / Doctor Name Search",
            "btnGroup": {
                "btn_zk": "Transfer Department",
                "btn_zys": "Change Doctor",
                "btn_zc": "Bed Transfer",
                "btn_fy": "Transfer Fee Category"
            },
            "popPleaceHolder": {
                "newKS": "New Department",
                "newZZENYS": "New Attending Doctor",
                "newZZHIYS": "New Primary Care Doctor",
                "newZYYS": "New Resident Doctor",
                "newBQ": "New Ward",
                "newBC": "New Bed",
                "newFYLB": "New Fee Category",
                "reason": "Transfer Reason"
            }
        },
        "giveConfirm": {
            "drugAdministrationDate": "Drug Administration Date",
            "btnGroup": {
                "btn_1": "Confirmation of Drug Administration(V)",
                "btn_2": "The patient is not present(O)",
                "btn_3": "Suspension of Drug Administration(☆)",
                "btn_4": "Discontinue Drug for the day(X)"
            },
            "longTermDrug": "Long-term Drug",
            "TemporaryDrug": "Temporary Drug",
            "tableSet": {
                "startTime": "Medical Orders Starting Time",
                "drugName": "Drug Name",
                "group": "Group",
                "dose": "Dose",
                "drugAdministrationTime": "Drug Administration Time",
                "drugAdministrationStatus": "Drug Administration Status"
            }
        }
    }
}